export const theme = {
    colors: {
      primary: '#2E7D32', // Forest green
      primaryDark: '#1B5E20', // Darker green
      primaryRGB: '46, 125, 50', // RGB values for rgba usage
      secondary: '#558B2F', // Sage green
      accent: '#CC5500', // Custom orange
      accentLight: '#E56717', // Lighter custom orange
      dark: '#212121',
      light: '#F5F5F5',
      textDark: '#333333',
      textLight: '#FFFFFF'
    },
    fonts: {
      heading: "'Playfair Display', serif",
      body: "'Open Sans', sans-serif"
    },
    spacing: {
      section: '100px'
    },
    borderRadius: '8px',
    boxShadow: '0 5px 15px rgba(0, 0, 0, 0.1)'
  };  